import { DataLakeQuery, Query } from 'dashboard-services';

import getApiConfig from 'api/ApiConfig';
import Formulas from 'resources/constants/Formulas';
import { AuthUtils } from 'utils';

import Papa from 'papaparse';

export default(() => {
  const FILE_PREFIX = "File: "
  const GROUP_PREFIX = " in group: "
  

  const searchFilesCore = ({ query, size, from = 0, noFetching = true, requestIdPrefix } = {}) => async dispatch => {
    const config = dispatch(getApiConfig()),
          getQueryBuilder = () => new Query.Builder(config)
            .withFetching(!noFetching)
            .withShouldDisplayError(!noFetching)
            .withRequestIdPrefix(requestIdPrefix),
          { queryFn } = DataLakeQuery.QUERIES.searchFiles(getQueryBuilder, {
            query: query || "*",
            size
          })
    return await queryFn({
      signal: new AbortController().signal,
      pageParam: from,
    })
  }

  const readFile = ({ fileId }) => async dispatch => {
    if(!fileId) {
      return Promise.resolve();
    }
    const getQueryBuilder = () => 
      new Query.Builder(dispatch(getApiConfig()))
        .withOnParse(response => Promise.resolve(response)),
      { mutationFn: getFileContentCall } = DataLakeQuery.QUERIES.getFileContentMutation(getQueryBuilder, { id: fileId })
    return new Promise((resolve, reject) =>
      getFileContentCall()
        .then(response => response.text())
        .then(response => response?.replace(/\n"/g, '"'))
        .then(content => 
          Papa.parse(content, {
            complete: result => {
              const newResult = result.data
              if(newResult[newResult.length - 1]?.length !== newResult[0]?.length) {
                newResult.pop()
              }
              return resolve(newResult)
            },
            error: err => {
              reject(err)
              console.error(String(err))
            }
          })
      ).catch(err => {
        dispatch(AuthUtils.sendError({ error: "(readFile)" + err.stack }))
        console.error(String(err))
        reject(err)
      })
    )
  }

  const isFileFormula = formula => formula?.includes(Formulas.LOAD_FILE) || formula?.includes(Formulas.LOAD_FILE.replaceAll(".", "_"))

  const validateTable = ({ item = [], cellValue, cell, formula }) => {
    if(!cellValue || String(cellValue).startsWith(FILE_PREFIX) && (isFileFormula(formula))) {
      return item.concat({
        formula,
        fileName: String(cellValue).slice(FILE_PREFIX.length, String(cellValue).indexOf(GROUP_PREFIX)),
        groupName: String(cellValue).slice(String(cellValue).indexOf(GROUP_PREFIX) + GROUP_PREFIX.length),
        prefix: FILE_PREFIX,
        address: cell.address
      })
    }
    return item
  }

  return {
    FILE_PREFIX,
    searchFilesCore,
    GROUP_PREFIX,
    readFile,
    validateTable,
    isFileFormula
  }
})()